const routes = {
    HOME_PAGE: '/',
    ERROR_404: '/fehler-404'
}

export default routes